module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/commons/templates/LeaveRequestModal/Rejection.ejs -->\n<strong>Reject reason:</strong>\n<div class="row">\n    <div class="col-sm-12 text-center">\n        '+
((__t=( model.get('rejectReason') || '-' ))==null?'':_.escape(__t))+
'\n    </div>\n</div>\n<hr/>\n<div>\n    <strong>Rejected by:\n        '+
((__t=( model.get('rejectedByName') || '-' ))==null?'':_.escape(__t))+
'\n    </strong>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/commons/templates/LeaveRequestModal/Rejection.ejs
// module id = 898
// module chunks = 1